<template>
  <div class="paymentForm">
    <Attention v-if="updatePaymentError.error_message" :text="updatePaymentError.error_message"/>
    <p class="town-card__img">
    <img width="160" src="https://websmart.zappallas.com/web_image?url=http%3A%2F%2Fwebpayment.smart-srv%2Fimage%3Fid%3D11315" alt="card">
    </p>
    <form-credit-card
      label="カード番号"
      name="cc_number"
      data-vv-name="cc_number"
      data-vv-value-path="formattedValue"
      v-model="ccNumber"
      :validation="{ rules: {
        required: true,
        credit_card: true
      } }"
    />
    <form-credit-expire
      name=""
      label="カード有効期限"
      month-name="cc_expiration_m"
      year-name="cc_expiration_y"
      :validation="{ rules: {
        required: true
        } }"
      v-model="ccExpiration"
    />
    <form-security-code v-model="securityCode" />
    <BaseButton class="paymentRegistForm__button" :is-disabled="buttonIsDisabled" :label="card.number ? '変更' : '登録する'" @clicked="updateCardData"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import BaseButton from './common/BaseButton'
import Attention from './common/Attention'
export default {
  name: 'payment-form',
  components:{
    Attention,
    BaseButton
  },
  data() {
    return {
      ccNumber: '',
      ccExpiration: '',
      securityCode: '',
      updatePaymentError: {},
      buttonIsDisabled: false,
      validateFlags: {},
    }
  },
  props: {
    merchantId: String,
    serviceId: String,
    action: String,
    token: String
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
    }),
  },
  mounted(){
    this.validateFlags = this.$validator.flags
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    }
  },
  methods: {
    isValid() {
      if (!this.ccNumber || this.securityCode.length <= 2 || !this.ccExpiration.month || !this.ccExpiration.year || !!this.$validator.errors.items.length) {
        this.updatePaymentError = { error_message: '入力されていない項目があります。'}
        window.scrollTo(0, 0);
        return false
      }
      this.updatePaymentError = {}
      return true
    },
    updateCardData() {
      if (!this.isValid()) return
      if (!window.com_sbps_system) throw new Error('Error: window.com_sbps_system がありません。')
      const data = {
        merchantId: this.merchantId,
        serviceId: this.serviceId,
        ccNumber: this.ccNumber,
        ccExpiration: `20${this.ccExpiration.year}${
          this.ccExpiration.month
        }`,
        securityCode: this.securityCode
      }
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.updatePaymentError = {}
        const { tokenResponse } = response
        this.$store.dispatch(type.UPDATE_PAYMENT_INFO, {
          access_token: this.accessToken,
          token: tokenResponse.token,
          tokenKey: tokenResponse.tokenKey
        }).then(() => {
          const message = {
            message: 'お支払い情報を更新しました。',
            type: 'success'
          }
          this.$message(message)
        }).then(() => {
          window.location.href = '/user/account/status'
        }).catch(error => {
          let message = ''
          if( error.error_title ) message += `${error.error_title}<br>`
          if( error.error_code ) message += `エラーコード：${error.error_code}<br>`
          message += error.error_message
          this.updatePaymentError = { error_message: message }
        })
      } else {
        this.updatePaymentError = response.errorMessage
      }
    }
  }
}</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.paymentForm{
  color: $col_base_black;
  padding: 20px 30px;
  max-width: 580px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PaymentForm.vue